<template>
  <div class=''>
    <label v-bind:for='valueList.instanceGuid' v-text='(valueList.nickName.length <= 0) ? "Unknown" : valueList.nickName'></label>
    <div class='item'>
      <select @change="updateQuery(valueList.instanceGuid, 'select')" ref="select" v-bind:id='valueList.instanceGuid' v-model='value'>
        <option ref="option" v-for='(key, idx) in valueList.keys' :key="idx" v-bind:value='valueList.values[idx]' v-text='key'>
        </option>
      </select>
    </div>
  </div>
</template>

<script>

import UIBase from './UIBase.vue';

export default {
  name: 'ValueList',
  extends: UIBase,
  components: {
  },
  props: {
    valueList: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    value: {
      get () {
        return this.valueList.values[this.valueList.selected];
      },
      set (v) {
        let index = this.valueList.values.indexOf(v);
        if (this.valueList.value !== index) {
          this.valueList.change(index);
        }
      }
    }
  },
  data () {
    return {
    };
  },
  mounted () {
    console.log(this.valueList);
    let variables = this.getQueryVariable();
    for(let variable of variables){
      if(this.valueList.instanceGuid == variable[0]){
        for(let [index, value] of this.valueList.values.entries()){
          if(value == variable[1]){
            if (this.valueList.value !== index) {
              this.valueList.change(index);
              let options = this.$refs.option;
              options.forEach( (o) => {
                o.selected = false
              } );
              options[index].selected = true;
            }
          }
        }
      } else{
        continue;
      }
    }
  },
  methods: {
    updateQuery (key, ref) {
      let value = this.$refs.select.value;
      const url = new URL(location.href);
      url.searchParams.set(key, value);
      history.pushState(null, '', url);
    },
  }
};

</script>



// WEBPACK FOOTER //
// src/components/ValueList.vue